export default "__VITE_ASSET__DwnexN$a__"